import { Box, CircularProgress } from '@mui/material';
import React, { memo } from 'react';

const PinLoader: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.14)',
      }}
    >
      <CircularProgress size={50} />
    </Box>
  );
};

PinLoader.displayName = 'PinLoader';

export default memo(PinLoader);
